module.exports = __webpack_public_path__ + "static/media/antigua-beaches-34.fe6492ec.jpg";